<template>
  <div class="network-behavior-wrap">
    <Widgest isOpenAll :widgestType="type === 'overview' ? 'outer' : 'inner'" :isBig="true">
      <template v-if="type === 'overview'" v-slot:title>{{$t('report.analyse.network')}}</template>
      <SandTab ref="tab" :data="tabData" class="network-table" @change="_handleTabChange"></SandTab>
      <sand-network :key="type" :taskid="taskId" :tab="tab" :header="columnData[tab]" :totalCount="networkCount[tab]"></sand-network>
    </Widgest>
  </div>
</template>

<script>
// 分析概览 及 网络分析 的 网络分析模块
import SandTab from '@/components/report/sandTab'
import SandNetwork from '@/components/report/sandNetwork'
import { isZh, t } from 'app/i18n'

export default {
  name: 'StaticInfo',
  components: {
    SandTab,
    SandNetwork
  },
  props: {
    networkCount: {
      type: Object
    },
    taskId: {
      type: String
    },
    type: {
      type: String
    }
  },
  computed: {
    columnData () {
      const overviewColumnData = {
        'traffic.alerts': [
          {
            prop: 'src_ip',
            label: '源IP地址',
            align: 'left'
          },
          {
            prop: 'dst_ip',
            label: '目的IP地址',
            align: 'left'
          },
          {
            prop: 'category',
            label: '类型',
            align: 'left'
          },
          {
            prop: 'severity',
            label: '严重程度',
            align: 'left'
          }
        ],
        hosts: [
          {
            prop: 'ip',
            label: 'IP地址',
            align: 'left'
          },
          {
            prop: 'country',
            label: '国家或地区',
            align: 'left'
          },
          {
            prop: 'city',
            label: '城市',
            align: 'left'
          },
          {
            prop: 'isp',
            label: 'ISP',
            align: 'left'
          }
        ],
        dns: [
          {
            prop: 'area_name',
            label: '域名',
            align: 'left'
          },
          {
            prop: 'analyse',
            label: '解析结果',
            align: 'left'
          }
        ]
      }
      for (const k in overviewColumnData) {
        overviewColumnData[k].map(v => {
          v.label = t(`report.network.${k}.${v.prop}`)
          return v
        })
      }
      if (this.networkCount['traffic.alerts'] === 0) {
        delete overviewColumnData['traffic.alerts']
      }
      return overviewColumnData
    },
    tabData () {
      const keys = Object.keys(this.columnData)
      const cn = {
        'traffic.alerts': '流量检测',
        hosts: '主机',
        dns: '域名'
      }
      const resultData = keys.map(item => {
        let label = `${item.toUpperCase()}(${this.networkCount[item]})`
        for (const key in cn) {
          if (key === item && isZh()) {
            label = `${cn[key]}(${this.networkCount[item]})`
          }
        }
        return {
          label,
          name: item
        }
      })
      return resultData
    }
  },
  data () {
    return {
      tab: this.networkCount['traffic.alerts'] !== 0 ? 'traffic.alerts' : 'hosts'
    }
  },
  methods: {
    _handleTabChange (tab) {
      this.tab = tab
    }
  }
}
</script>

<style lang="scss" scoped>
// 点击进入网络分析再返回 网络概要有active状态
.network-behavior-wrap {
  :deep(.sand-tableCollapse__header .font) {
    color: var(--color-text-2);
  }
  :deep(.sand-tableCollapse__header) {
    width: calc(100% - 51px) !important;
  }
  :deep(.sandNetwork-wrap .sand-tableCollapse__header--tags) {
    margin-left: 10px;
  }
}
</style>
